import React from "react";
import { Panel, Table } from "react-bootstrap";
import Moment from "react-moment";
import PhoneNumber from "../Shared/PhoneNumber";

const CallRecordPanel = ({ smsRecords }) => {
  return (
    <Panel bsStyle="success" className="compact-panel">
      <Panel.Heading>
        <Panel.Title componentClass="h3">Related SMS Records</Panel.Title>
      </Panel.Heading>
      <Panel.Body style={{ padding: 3 }}>
        {smsRecords && smsRecords.length > 0 ? (
          <Table bordered condensed hover style={{ fontSize: 13 }}>
            <thead className="dark">
              <tr>
                <th style={{ width: 10 }}>ID</th>
                <th>At</th>
                <th>Message</th>
              </tr>
            </thead>
            {smsRecords.map((sms_record, index) => {
              const lmUrl = `https://meridianone.leadmachine.com/app#!/message_centre/messages/inbox/${sms_record.lm_thread_id}`;
              return (
                <tbody key={index}>
                  <tr>
                    <td data-label="ID">#{sms_record.id}</td>
                    <td data-label="At" style={{ whiteSpace: "nowrap" }}>
                      <div>
                        <Moment
                          format="MMM Do YYYY h:mma"
                          style={{
                            fontSize: 13,
                            borderBottom: "1px solid #ccc",
                            marginBottom: 4
                          }}
                        >
                          {sms_record.at}
                        </Moment>
                      </div>
                      <div>
                        <span style={{ width: 45, display: "inline-block" }}>
                          From:
                        </span>{" "}
                        {sms_record.direction === "in" ? (
                          <span>
                            <PhoneNumber
                              number={sms_record.contact_number}
                            ></PhoneNumber>
                          </span>
                        ) : (
                          <span>{sms_record.m1_number}</span>
                        )}
                      </div>
                      <div>
                        <span style={{ width: 45, display: "inline-block" }}>
                          To:
                        </span>{" "}
                        {sms_record.direction === "in" ? (
                          <span>
                            {sms_record.m1_number || "Emerson Coaching"}
                          </span>
                        ) : (
                          <span>
                            <PhoneNumber
                              number={sms_record.contact_number}
                            ></PhoneNumber>
                          </span>
                        )}
                      </div>
                      {sms_record.lm_thread_id && (
                        <div>
                          <a
                            href={lmUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            LeadMachine
                          </a>
                        </div>
                      )}
                    </td>
                    <td data-label="Message">
                      <div>
                        {sms_record.text &&
                          sms_record.text.split("\n").map((item, key) => {
                            return (
                              <span key={key}>
                                {item}
                                <br />
                              </span>
                            );
                          })}
                      </div>
                      {sms_record.delivery_status && (
                        <div>
                          {sms_record.delivery_status === "failed" ||
                          sms_record.delivery_status === "undelivered" ? (
                            <div
                              className="text-danger"
                              style={{ marginTop: 6 }}
                            >
                              {sms_record.delivery_status}:{" "}
                              {sms_record.error_code}:{" "}
                              {sms_record.error_message}
                            </div>
                          ) : (
                            <div
                              className="text-success pull-right"
                              style={{ marginTop: 3 }}
                            >
                              {sms_record.delivery_status}
                            </div>
                          )}
                        </div>
                      )}
                    </td>
                  </tr>
                </tbody>
              );
            })}
          </Table>
        ) : (
          <div style={{ margin: 10 }}>No SMS messages</div>
        )}
      </Panel.Body>
    </Panel>
  );
};

export default CallRecordPanel;
